import { useContext } from 'react'

import { SignatureFormContext } from '../context'

export function useCustomer() {
  const {
    customers,
    loadingCustomers: loading,
    listCustomers
  } = useContext(SignatureFormContext)

  return {
    customers,
    loading,
    listCustomers
  }
}
